module.exports = __webpack_public_path__ + "static/kamisato-ayato-banner-f9d3815a6eaf6f7ba1077854899906c3.webp";